/**
 * Moves an item within an array from one index to another, in place.
 *
 * Native drop-in replacement for the CDK drag-drop `moveItemInArray`
 * (same signature and clamping behaviour), so call sites migrate 1:1.
 */
export function moveItemInArray<T>(array: T[], fromIndex: number, toIndex: number): void {
  const from = clamp(fromIndex, array.length - 1);
  const to = clamp(toIndex, array.length - 1);
  if (from === to) {
    return;
  }
  const target = array[from];
  const delta = to < from ? -1 : 1;
  for (let i = from; i !== to; i += delta) {
    array[i] = array[i + delta];
  }
  array[to] = target;
}

/**
 * Moves an item from one array into another, inserting it at the target index. In place.
 *
 * Native drop-in replacement for the CDK drag-drop `transferArrayItem`
 * (same signature and clamping behaviour).
 */
export function transferArrayItem<T>(
  sourceArray: T[],
  targetArray: T[],
  sourceIndex: number,
  targetIndex: number
): void {
  const from = clamp(sourceIndex, sourceArray.length - 1);
  const to = clamp(targetIndex, targetArray.length);
  if (sourceArray.length) {
    targetArray.splice(to, 0, sourceArray.splice(from, 1)[0]);
  }
}

function clamp(value: number, max: number): number {
  return Math.max(0, Math.min(max, value));
}
